import { ReactNode } from 'react';
import { P2GBox, P2GContainer, P2GFade, P2GGrid, P2GText } from '@parcel2go/core-ui';

export interface IP2GMyAccountHeaderProps {
  title?: string;
  subTitle?: string;
  backControl?: ReactNode;
  actionControl?: ReactNode;
  isXs: boolean;
  variant: 'main' | 'quote';
  hasSidePanel: boolean;
}

export const P2GMyAccountHeader: React.FC<React.PropsWithChildren<IP2GMyAccountHeaderProps>> = (props) => {
  return (
    <P2GBox
      sx={(t) =>
        props.variant === 'quote'
          ? {}
          : {
              backgroundColor: 'white',
              borderRadius: props.isXs ? t.spacing(0, 0, 2, 2) : 0,
              boxShadow: `0px 10px 10px 5px ${t.palette.grey.A200}`,
              borderTop: `1px solid ${t.palette.grey.A200}`
            }
      }
    >
      <P2GFade in>
        <P2GContainer
          maxWidth={props.hasSidePanel ? false : 'lg'}
          sx={(t) => (props.hasSidePanel ? { padding: { lg: t.spacing(0, 4, 0, 4) } } : undefined)}
          classNames="p2g-myaccount-header"
        >
          <P2GBox sx={{ pt: 2, pb: 2 }}>
            <P2GGrid container alignItems="center" wrap="nowrap" gap={2} sx={{ minHeight: '35px' }}>
              {props.backControl && (
                <P2GGrid item flexShrink={1}>
                  {props.backControl}
                </P2GGrid>
              )}
              <P2GGrid item flexGrow={1}>
                <P2GText variant="h4">{props.title}</P2GText>
                {props.subTitle && (
                  <P2GBox>
                    <P2GText variant="body2" small>
                      {props.subTitle}
                    </P2GText>
                  </P2GBox>
                )}
              </P2GGrid>
              {props.actionControl && (
                <P2GGrid item flexShrink={1}>
                  {props.actionControl}
                </P2GGrid>
              )}
              {props.children}
            </P2GGrid>
          </P2GBox>
        </P2GContainer>
      </P2GFade>
    </P2GBox>
  );
};
